
import React from 'react'

const handledCloseSession = async (param) => {
    localStorage.clear();
    window.location.href = '/'
}

const NavBar = () => {

    return (
        <>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a href="!#" className="nav-link" data-widget="pushmenu" role="button"><i className="fas fa-bars"></i></a>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item dropdown">
                        <a href="!#" className="nav-link" data-toggle="dropdown">
                            <i className="nav-icon fas fa-user" style={{ color: 'lightseagreen' }}> {localStorage.getItem('userName')}</i>
                        </a>
                    </li>
                </ul>
            </nav>
        </>
    )
}

export default NavBar
